const OTC_ATTRIBUTE_KEYS = [
  'OTC - Data nașterii',
  'OTC - Greutate (kg)',
  'OTC - Înălțime (cm)',
  'OTC - Sex',
  'OTC - Sarcină',
  'OTC - Tratament',
  'OTC - Detalii tratament',
  'OTC - Alergii',
  'OTC - Detalii alergii',
  'OTC - Consimțământ',
  'OTC - Completat la',
];

class OtcCheckoutGate extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    this.error = this.querySelector('[role="alert"]');
    this.submitButton = this.form.querySelector('[type="submit"]');

    document.addEventListener('click', this.handleCheckoutClick, true);
    document.addEventListener('submit', this.handleCheckoutSubmit, true);
    this.form.addEventListener('change', this.syncConditionalFields);
    this.form.addEventListener('submit', this.saveAnswers);
    this.querySelectorAll('[data-otc-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));

    this.observer = new MutationObserver(this.syncCartState);
    this.observer.observe(document.body, { childList: true, subtree: true });
    this.syncConditionalFields();
    this.syncCartState();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleCheckoutClick, true);
    document.removeEventListener('submit', this.handleCheckoutSubmit, true);
    this.observer?.disconnect();
  }

  currentCartHasOtc = () => {
    const marker =
      document.querySelector('#main-cart-items [data-otc-cart-state]') ||
      document.querySelector('#CartDrawer [data-otc-cart-state]');
    return marker ? marker.dataset.cartHasOtc === 'true' : document.body.dataset.cartHasOtc === 'true';
  };

  syncCartState = () => {
    const hasOtc = this.currentCartHasOtc();
    const needsClear = !hasOtc && this.dataset.hasSavedAnswers === 'true';
    document.body.dataset.cartHasOtc = String(hasOtc);
    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons').forEach((element) => {
      element.hidden = hasOtc || needsClear;
    });

    if (this.clearingAnswers) this.setCheckoutDisabled(true);
    if (needsClear && !this.clearingAnswers && !this.clearFailed) this.clearAnswers();
  };

  isCheckoutControl = (element) => {
    const control = element.closest('button[name="checkout"], input[name="checkout"], a[href]');
    if (!control) return false;
    if (control.matches('[name="checkout"]')) return true;

    try {
      return new URL(control.href, window.location.origin).pathname.replace(/\/$/, '').endsWith('/checkout');
    } catch {
      return false;
    }
  };

  checkoutSource = (element) => {
    if (element.closest('cart-drawer')) return 'drawer';
    if (element.closest('product-info, product-form')) return 'product';
    return 'cart';
  };

  continueToCheckout = (source) => {
    document.dispatchEvent(new CustomEvent('ximena:checkout-started', { detail: { source } }));
    window.location.assign(this.checkoutUrl());
  };

  handleCheckoutClick = (event) => {
    if (!this.isCheckoutControl(event.target)) return;
    const source = this.checkoutSource(event.target);
    const hasOtc = this.currentCartHasOtc();
    const needsClear = !hasOtc && this.dataset.hasSavedAnswers === 'true';
    event.preventDefault();
    event.stopImmediatePropagation();
    if (hasOtc) this.open(source);
    else if (needsClear) {
      this.clearFailed = false;
      this.clearAnswers(true, source);
    } else this.continueToCheckout(source);
  };

  handleCheckoutSubmit = (event) => {
    if (event.target === this.form || event.submitter?.name !== 'checkout') return;
    const source = this.checkoutSource(event.submitter);
    const hasOtc = this.currentCartHasOtc();
    const needsClear = !hasOtc && this.dataset.hasSavedAnswers === 'true';
    event.preventDefault();
    event.stopImmediatePropagation();
    if (hasOtc) this.open(source);
    else if (needsClear) {
      this.clearFailed = false;
      this.clearAnswers(true, source);
    } else this.continueToCheckout(source);
  };

  open = (source = 'cart') => {
    this.pendingCheckoutSource = source;
    document.querySelector('cart-drawer.active')?.close();
    this.error.hidden = true;
    this.syncConditionalFields();
    if (!this.dialog.open) this.dialog.showModal();
    this.form.querySelector('input, select')?.focus();
  };

  syncConditionalFields = () => {
    const sex = this.form.elements.sex;
    const pregnancy = this.form.elements.pregnancy;
    const medication = this.form.elements.on_medication;
    const medicationDetails = this.form.elements.medication_details;
    const allergies = this.form.elements.allergies;
    const allergyDetails = this.form.elements.allergy_details;

    const showPregnancy = sex.value === 'F';
    this.querySelector('[data-otc-pregnancy]').hidden = !showPregnancy;
    pregnancy.required = showPregnancy;

    const showMedicationDetails = medication.value === 'Da';
    this.querySelector('[data-otc-medication-details]').hidden = !showMedicationDetails;
    medicationDetails.required = showMedicationDetails;

    const showAllergyDetails = allergies.value === 'Da';
    this.querySelector('[data-otc-allergy-details]').hidden = !showAllergyDetails;
    allergyDetails.required = showAllergyDetails;
  };

  validateAdult = () => {
    const input = this.form.elements.date_of_birth;
    input.setCustomValidity('');
    if (!input.value) return;

    const birthday = new Date(`${input.value}T00:00:00`);
    const today = new Date();
    const latestAdultBirthday = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    if (Number.isNaN(birthday.valueOf()) || birthday > latestAdultBirthday) {
      input.setCustomValidity('Trebuie să aveți cel puțin 18 ani.');
    }
  };

  saveAnswers = async (event) => {
    event.preventDefault();
    this.validateAdult();
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      this.showError('Verifică toate câmpurile obligatorii înainte de a continua.');
      return;
    }

    const values = new FormData(this.form);
    const attributes = {
      'OTC - Data nașterii': values.get('date_of_birth'),
      'OTC - Greutate (kg)': values.get('weight'),
      'OTC - Înălțime (cm)': values.get('height'),
      'OTC - Sex': values.get('sex'),
      'OTC - Sarcină': values.get('sex') === 'F' ? values.get('pregnancy') : 'Nu se aplică',
      'OTC - Tratament': values.get('on_medication'),
      'OTC - Detalii tratament': values.get('on_medication') === 'Da' ? values.get('medication_details') : 'Nu se aplică',
      'OTC - Alergii': values.get('allergies'),
      'OTC - Detalii alergii': values.get('allergies') === 'Da' ? values.get('allergy_details') : 'Nu se aplică',
      'OTC - Consimțământ': values.get('consent'),
      'OTC - Completat la': new Date().toISOString(),
    };

    this.setSaving(true);
    try {
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!response.ok) throw new Error('Cart attributes were not accepted');

      const updatedCart = await response.json();
      if (Object.entries(attributes).some(([key, value]) => updatedCart.attributes?.[key] !== value)) {
        throw new Error('Cart attributes were not persisted');
      }

      this.dataset.hasSavedAnswers = 'true';
      this.continueToCheckout(this.pendingCheckoutSource || 'cart');
    } catch (error) {
      console.error(error);
      this.showError('Datele nu au putut fi salvate. Te rugăm să încerci din nou.');
      this.setSaving(false);
    }
  };

  clearAnswers = async (continueToCheckout = false, source = 'cart') => {
    if (this.clearingAnswers) return;
    this.clearingAnswers = true;
    this.setCheckoutDisabled(true);
    try {
      const attributes = Object.fromEntries(OTC_ATTRIBUTE_KEYS.map((key) => [key, '']));
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!response.ok) throw new Error('Stale OTC attributes were not cleared');
      this.dataset.hasSavedAnswers = 'false';
      this.clearFailed = false;
      if (continueToCheckout) this.continueToCheckout(source);
    } catch (error) {
      console.error(error);
      this.clearFailed = true;
      if (continueToCheckout) window.alert('Datele OTC vechi nu au putut fi eliminate. Te rugăm să încerci din nou.');
    } finally {
      this.clearingAnswers = false;
      this.setCheckoutDisabled(false);
      this.syncCartState();
    }
  };

  setCheckoutDisabled = (disabled) => {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((control) => {
      if (disabled && control.dataset.otcOriginallyDisabled === undefined) {
        control.dataset.otcOriginallyDisabled = String(control.disabled);
        control.disabled = true;
      } else if (!disabled && control.dataset.otcOriginallyDisabled !== undefined) {
        control.disabled = control.dataset.otcOriginallyDisabled === 'true';
        delete control.dataset.otcOriginallyDisabled;
      }
    });
  };

  checkoutUrl = () => {
    const url = window.routes.cart_url.replace(/\/cart\/?$/, '/checkout');
    const locale = window.Shopify?.locale || document.documentElement.lang.split('-')[0];
    return `${url}?locale=${encodeURIComponent(locale)}`;
  };

  showError = (message) => {
    this.error.textContent = message;
    this.error.hidden = false;
    this.error.focus();
  };

  setSaving = (saving) => {
    this.submitButton.disabled = saving;
    this.submitButton.textContent = saving ? 'Se salvează…' : 'Salvează și continuă la plată';
  };
}

customElements.define('otc-checkout-gate', OtcCheckoutGate);
